import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";
import { F, CShell } from "@/components/careers/ui";
import { ApplicationsPanel } from "@/components/careers/ApplicationsPanel";
import { JobPostsPanel } from "@/components/careers/JobPostsPanel";
import { InvitesPanel } from "@/components/careers/InvitesPanel";
import { InterviewsPanel } from "@/components/careers/InterviewsPanel";
import { ScriptsPanel } from "@/components/careers/ScriptsPanel";

const TABS = [["applications", "Applications"], ["interviews", "Interviews"], ["jobs", "Job posts"], ["scripts", "Voice scripts"], ["invites", "Send application"]];

export default function HiringAdmin() {
  const [tab, setTab] = useState("applications");
  const [jobs, setJobs] = useState([]);
  const [team, setTeam] = useState({ leaders: [], is_admin: false });
  const load = useCallback(() => api.get("/api/careers/admin/jobs").then(r => setJobs(r.data)).catch(e => toast.error(errMsg(e))), []);
  useEffect(() => { load(); api.get("/api/academy/team").then(r => setTeam(r.data)).catch(() => {}); }, [load]);
  return (
    <CShell testId="hiring-admin">
      <div className="flex flex-wrap items-end gap-4"><div className="flex-1"><p className="text-xs font-bold uppercase tracking-[0.25em] text-amber-600">Training center</p><h1 className="text-4xl sm:text-5xl font-extrabold text-slate-900 tracking-tight" style={F}>Hiring</h1></div>
        <Link to="/careers" target="_blank" className="h-10 px-5 leading-10 rounded-full border border-slate-300 text-sm font-semibold" data-testid="hiring-public-link">View careers page</Link>
        <Link to="/admin/sales-training" className="h-10 px-5 leading-10 rounded-full border border-slate-300 text-sm font-semibold" data-testid="hiring-training-link">Sales training</Link></div>
      <div className="flex gap-1 overflow-x-auto" data-testid="hiring-tabs">{TABS.map(([k, l]) => <button key={k} onClick={() => setTab(k)} className={`shrink-0 px-4 h-9 rounded-full text-sm font-bold transition-colors ${tab === k ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-white"}`} data-testid={`hiring-tab-${k}`}>{l}</button>)}</div>
      {tab === "applications" && <ApplicationsPanel jobs={jobs} leaders={team.leaders} isAdmin={team.is_admin} />}
      {tab === "jobs" && <JobPostsPanel jobs={jobs} reload={load} />}
      {tab === "invites" && <InvitesPanel jobs={jobs} />}
      {tab === "interviews" && <InterviewsPanel />}
      {tab === "scripts" && <ScriptsPanel />}
    </CShell>
  );
}
